import React, { useState } from "react";
import "../styles/theme.css";
import "../styles/login.css";
import logo from "../assets/korridor_logo.png";
import { useNavigate } from "react-router-dom";
import { login } from "../functions/api/users";

const LoginPage: React.FC = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	// Handle showing errors
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const handleLogin = async (e: React.FormEvent) => {
		e.preventDefault();
		
		// authentication logic
		setError("");
		try {
			await login(username, password);
			navigate("/home");
		} catch (err: any) {
			setError("Login failed. Check your credentials.");
			console.error(err);
		}
	};

	return (
		<div className="login-container">
			<div className="login-box">
				<img src={logo} alt="FuelSureLogo" className="login-logo" />

				<h2 className="login-title">Login</h2>
				<form onSubmit={handleLogin}>
					<div className="form-group">
						<label htmlFor="username">Username</label>
						<input
							type="text"
							id="username"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							required
						/>
					</div>

					<div className="form-group">
						<label htmlFor="password">Password</label>
						<input
							type="password"
							id="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
						/>
					</div>

					<button type="submit" className="button">
						Login
					</button>
				</form>
			</div>
		</div>
	);
};

export default LoginPage;
